// extracted by mini-css-extract-plugin
module.exports = {"btnGroup":"MFAOptionsSwitch_btnGroup__1AAox","customBtnStyles":"MFAOptionsSwitch_customBtnStyles__12WGX"};